import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import MaterialModal from "../MaterialModal";
import { MuiPickersUtilsProvider, KeyboardDatePicker } from "@material-ui/pickers";
import Moment from "moment";
import MomentUtils from "@date-io/moment";
import { parseDate } from "../../../helpers/parseDate";
import withModal from "../withModal";
import { hideModal } from "../../../actions/actionCreators";
import { GetLogMessages } from "../../../actions/logMessageActions";

type ModalProps = {
    setStartDate: (value: string) => void;
    setEndDate: (value: string) => void;
    intialStarDate: string;
    intialEndDate: string;
};

type Props = {
    isOpen: boolean;
    modalProps: ModalProps;
};

const DateFilter: React.FC<Props> = ({ isOpen, modalProps }: Props) => {
    const dispatch = useDispatch();

    const [start, setStartDate] = useState(modalProps.intialStarDate);
    const [end, setEndDate] = useState(modalProps.intialEndDate);

    useEffect(() => {
        setStartDate(modalProps.intialStarDate);
        setEndDate(modalProps.intialEndDate);
    }, [modalProps.intialEndDate, modalProps.intialStarDate]);

    const hide = () => dispatch(hideModal("DATE_FILTER"));

    const searchClick = () => {
        dispatch(GetLogMessages(start, end));
        hide();
    };

    const setMomentDate = (type, momentObj) => {
        if (!momentObj || (momentObj && momentObj.utc().format() == "Invalid date")) {
            return false;
        }

        const d = parseDate(momentObj.utc().format()).toJSON().slice(0, 10).replace(/-/g, "/");
        if (type == "start") {
            setStartDate(d);
            modalProps.setStartDate(d);
        } else if (type == "end") {
            setEndDate(d);
            modalProps.setEndDate(d);
        }
    };

    return (
        <MaterialModal
            id="date-filter-modal"
            isOpen={isOpen}
            title="Date Filter"
            onClose={hide}
            cancelButtonText="Cancel"
            onPrimaryButtonRequest={searchClick}
            primaryButtonText="Search"
            isPrimaryButtonDisabled={start > end}
        >
            <div style={{ display: "flex", alignItems: "center", minHeight: "150px" }}>
                <MuiPickersUtilsProvider utils={MomentUtils}>
                    <div style={{ margin: 5 }}>
                        <KeyboardDatePicker
                            variant="inline"
                            format="MM/DD/YYYY"
                            margin="normal"
                            id="begin-date-range"
                            label="Begin Date"
                            value={Moment(start, "YYYY/MM/DD")}
                            onChange={momentObj => setMomentDate("start", momentObj)}
                            KeyboardButtonProps={{
                                "aria-label": "change date",
                            }}
                            disableFuture
                        />
                    </div>
                    <div style={{ margin: 5 }}>
                        <KeyboardDatePicker
                            variant="inline"
                            format="MM/DD/YYYY"
                            margin="normal"
                            id="end-date-range"
                            label="End Date"
                            value={Moment(end, "YYYY/MM/DD")}
                            onChange={momentObj => {
                                setMomentDate("end", momentObj);
                            }}
                            KeyboardButtonProps={{
                                "aria-label": "change date",
                            }}
                            error={start > end}
                            helperText={start > end ? "End date should be greater." : null}
                            disableFuture
                        />
                    </div>
                </MuiPickersUtilsProvider>
            </div>
        </MaterialModal>
    );
};

export default withModal(DateFilter, "DATE_FILTER");
